import {
  AppBar,
  Avatar,
  Box,
  Button,
  IconButton,
  Skeleton,
  Stack,
  Toolbar,
  Tooltip,
  styled
} from '@mui/material';
import {
  CustomIcons,
  InviteUserModal,
  authUtil
} from 'modules';
import React, {
  useCallback,
  useState
} from 'react';
import {
  useLocation,
  useNavigate
} from 'react-router-dom';
import { theme } from 'theme';
import * as ds from './dataService';



const ProfilePictureBox = styled('div')({
  marginLeft: '1rem',
  height: '4rem',
  backgroundColor: 'white',
  width: '4rem',
  borderRadius: '1rem',
  boxShadow: '0px 8px 24px 0px #474e4b5',
  padding: '0.75rem 0.8125rem',
  cursor: 'pointer'
});

const ProfilePictureImg = styled('img')({
  width: '100%',
  height: '100%',
  borderRadius: '0.5rem'
});

export type HeaderNavbarProps = {};

export const FC = (props: HeaderNavbarProps) => {
  const [
    inviteIsVisible,
    setInviteIsVisible
  ] = useState(false);
  const queryTuple = ds.useQuery();

  const location = useLocation();

  const navigate = useNavigate();

  const handleLogout = useCallback(async () => {
    await authUtil.signOut();
  }, []);


  const handleClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>, path: string) => {
    if (e.currentTarget.name === 'macroeconomics') {
      if (path.endsWith('macroeconomics')) {
        return;
      } else {
        return navigate('/macroeconomics');
      }
    } else if (e.currentTarget.name === 'company') {
      if (path.endsWith('company')) {
        return;
      } else {
        return navigate('/company');
      }
    } else if (e.currentTarget.name === 'admin') {
      if (path.includes('admin')) {
        return;
      } else {
        return navigate('/admin');
      }
    } else if (e.currentTarget.name === 'insights') {
      if (path.endsWith('insights')) {
        return;
      } else {
        return navigate('/insights');
      }
    } else if (e.currentTarget.name === 'sentiment') {
      if (path.endsWith('sentiment')) {
        return;
      } else {
        return navigate('/sentiment');
      }
    } else if (e.currentTarget.name === 'customize') {
      if (path.endsWith('customize')) {
        return;
      } else {
        return navigate('/customize');
      }
    }
  };

  if (queryTuple.loading) {
    return <></>;
  }



  return (
    <>
      {inviteIsVisible && (
        <InviteUserModal.FC
          isVisible={inviteIsVisible}
          onClose={() => setInviteIsVisible(() => false)}
        />
      )}
      <Box
        display='flex'
        flexDirection='row'
        paddingY='1.5rem'
      >
        <AppBar
          elevation={0}
          color='transparent'
          position='static'
        >
          <Toolbar disableGutters>
            <IconButton
              sx={{
                marginRight: '2.5rem'
              }}
            >
              <CustomIcons.LargeIcon.FC icon='COMPANYLOGOFULL' />
            </IconButton>
            {/* <Button
              variant = 'contained'
              color = 'primary'
              onClick = {() => setInviteIsVisible(() => true)}
            >
              Invite User
            </Button> */}

            <Box
              display='flex'
              borderRadius='1rem'
              flexDirection='row'
              flexWrap='wrap'
              paddingX='1rem'
              paddingY='.75rem'
              flex='1 1 0'
              bgcolor='white'
              justifyContent='space-between'
            >

              <Box
                display='flex'
                alignItems='center'
                flexWrap='wrap'
                columnGap='.75rem'
              >
                <Button
                  name='insights'
                  onClick={(e) => handleClick(e, location.pathname)}
                  variant={
                    location.pathname.includes('insights')
                      ? 'selectedNav'
                      : 'notSelectedNav'
                  }
                  startIcon={(
                    <CustomIcons.SmallCustomIcon.FC
                      icon='COMMENT'
                      stroke={
                        location.pathname.includes('insights')
                          ? '#67726D'
                          : theme.palette.primary.main
                      }
                    />
                  )}
                >
                  Sherlock AI Insights
                </Button>

                <Button
                  onClick={(e) => handleClick(e, location.pathname)}
                  name='macroeconomics'
                  variant={
                    location.pathname.endsWith('macroeconomics')
                      ? 'selectedNav'
                      : 'notSelectedNav'
                  }
                  startIcon={(
                    <CustomIcons.MediumIcon.FC
                      icon='LINECHART'
                      stroke={
                        location.pathname.endsWith('macroeconomics')
                          ? 'white'
                          : '#67726D'
                      }
                    />
                  )}
                >
                  MacroEconomics
                </Button>

                <Button
                  name='company'
                  onClick={(e) => handleClick(e, location.pathname)}
                  variant={
                    location.pathname.endsWith('companies') || location.pathname.includes('company')
                      ? 'selectedNav'
                      : 'notSelectedNav'
                  }
                  startIcon={(
                    <CustomIcons.MediumIcon.FC
                      icon='COLUMNCHART'
                      stroke={
                        location.pathname.endsWith('macroeconomics')
                          ? '#67726D'
                          : theme.palette.primary.main
                      }
                    />
                  )}
                >
                  Company Profiles
                </Button>

                {queryTuple.data.isSuperAdmin && (
                  <Button
                    name='admin'
                    onClick={(e) => handleClick(e, location.pathname)}
                    variant={
                      location.pathname.includes('admin')
                        ? 'selectedNav'
                        : 'notSelectedNav'
                    }
                  >
                    Super Admin
                  </Button>
                )}

                {queryTuple.data.isSuperAdmin && (
                  <Button
                    name='sentiment'
                    onClick={(e) => handleClick(e, location.pathname)}
                    variant={
                      location.pathname.includes('sentiment')
                        ? 'selectedNav'
                        : 'notSelectedNav'
                    }
                  >
                    Sentiment
                  </Button>
                )}

                <Button
                  name='customize'
                  onClick={(e) => handleClick(e, location.pathname)}
                  variant={
                    location.pathname.includes('customize')
                      ? 'selectedNav'
                      : 'notSelectedNav'
                  }
                >
                  Customize
                </Button>


              </Box>
              <Stack
                direction='row'
                alignItems='center'
                columnGap='.5rem'
              >
                <IconButton
                  sx={{
                    backgroundColor: 'white',
                    borderRadius: '.5rem',
                    border: '1px solid #D9DDDB',
                    padding: '.75rem'
                  }}
                >
                  <CustomIcons.MediumIcon.FC icon='NOTIFICATIONS' />
                </IconButton>

                <Tooltip title='Sign out'>
                  <IconButton
                    sx={{
                      backgroundColor: 'white',
                      borderRadius: '.5rem',
                      border: '1px solid #D9DDDB',
                      padding: '.75rem'
                    }}
                    onClick={() => handleLogout()}
                  >

                    <CustomIcons.MediumIcon.FC
                      stroke={theme.palette.gray.light60}
                      icon='LOGOUT'
                    />
                  </IconButton>
                </Tooltip>
              </Stack>
            </Box>

            {queryTuple.loading && (
              <Skeleton
                sx={{
                  marginLeft: '1rem'
                }}
                variant='rounded'
                height='4rem'
                width='4rem'
              />
            )}

            {!queryTuple.loading && (
              <ProfilePictureBox
                onClick={() => {
                  navigate('/account');
                }}
              >
                {queryTuple.data.profilePictureUrl
                  ? (
                    <ProfilePictureImg src={queryTuple.data.profilePictureUrl} />
                  )
                  : (
                    <Avatar />
                  )}
              </ProfilePictureBox>
            )}
          </Toolbar>
        </AppBar>
      </Box>
    </>
  );
};
